import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { useWorkspace } from '../../integrationQA/context/WorkspaceContext';
import { AiQuotaBanner, useAiUsage } from '../ai/AiUsage';
import { isEndpointConnected } from '../../api/connection';

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const { can } = useWorkspace();
  const { usage } = useAiUsage({ enabled: can('billing:read') && isEndpointConnected('GET', '/api/ai/usage') });

  useEffect(() => setOpen(false), [pathname]);
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  return (
    <div className="cb-shell">
      <a href="#main" className="visually-hidden-focusable cb-skip">Skip to main content</a>
      <Sidebar open={open} onClose={() => setOpen(false)} />
      <div className="cb-main">
        <Topbar onMenu={() => setOpen((o) => !o)} menuOpen={open} />
        <AiQuotaBanner usage={usage} />
        <main id="main" className="cb-content" tabIndex={-1}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
